import { render } from "./ConsultationForm.vue?vue&type=template&id=cef2d0de"
import script from "./ConsultationForm.vue?vue&type=script&lang=js"
export * from "./ConsultationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__